<div class="swiper-body-container" #swiperBodyContainer>

  <div class="swiper-body-wrapper" #swiperBodyWrapper>
    <ng-content></ng-content>
  </div>
  
</div>
